import useFlag from 'hooks/useFlag'

const useMenuLayoutEnabled = (): boolean => useFlag('menu-layout-mx', false)

export default useMenuLayoutEnabled
